var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._b(
      {
        ref: "trustBox",
        staticClass: "trustpilot-widget",
        attrs: {
          "data-businessunit-id": _vm.businessId,
          "data-locale": _vm.getLocale,
          "data-style-width": "100%",
          "data-theme": "light",
          "data-font-family": "Lato",
          "data-text-color": "#1F1F24",
          "data-third-party-reviews": "true",
        },
      },
      "div",
      Object.assign({}, _vm.$props, _vm.$attrs),
      false
    ),
    [
      _c(
        "a",
        { attrs: { href: _vm.target, target: "_blank", rel: "noopener" } },
        [_vm._v("Trustpilot")]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }